import React, { useCallback, useEffect, useRef, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import PageLoading from "../../../components/loader/PageLoading";
import SearchIcon from "@mui/icons-material/Search";

import { getFeatureType, show_proper_words } from "../../../utils/Constant";
import {
  _get_training_list_blog_api,
  _get_training_list_blog_api_new,
} from "../../../DAL/TalentSourceAPI/TalentSourceApi";
import { useIds } from "../../../hook/AdminContext";
import { useSnackbar } from "notistack";
import { CircularProgress, InputAdornment, TextField } from "@mui/material";
import { s3baseUri } from "../../../config/config";
import RecordNotFound from "../../../components/recordNotFound/RecordNotFound";
import PartnersSkeleton from "../../../components/loader/PartnerTypeSkelton";
import {
  comine_blogs_api,
  get_categories_api,
} from "../../../DAL/categoryBlogs/ComineData";
import { podcast_against_category } from "../../../DAL/podcast/podcast";
import BlogCard from "./components/BlogCard";

export default function BlogListCard() {
  const location = useLocation();
  const navigate = useNavigate();
  const { setBreadCrumb, userInfo } = useIds();
  const [featureType, setFeatureType] = useState("");
  const firstSegment = location.pathname.split("/")[1];
  const { enqueueSnackbar } = useSnackbar();
  const observer = useRef();
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchText, setSearchText] = useState("");
  const [totalPages, setTotalPages] = useState(0);
  const [pageNumber, setPageNumber] = useState(0);
  const [loadMorePath, setLoadMorePath] = useState("");
  const [isLoadingMore, setIsLoadingMore] = useState(false);
  const load_more_path =
    "aapi/blog/get_blog_by_category_slug/?page=1&0imit=100";
  const params = useParams();

  const fetchCategories = async (path, search, loading) => {
    if (!loading) {
      setLoading(true);
      path = load_more_path;
    }
    let response =
      featureType == "Podcasts"
        ? await podcast_against_category(
            params.category_slug,
            search,
            params.source_slug,
            params.feature_slug
          )
        : await comine_blogs_api(
            params.category_slug,
            search,
            params.source_slug,
            params.feature_slug
          );
    if (response.code === 200) {
      let name = featureType == "Podcasts" ? "podcast_blog" : "blog";

      setLoadMorePath(response.load_more_url);
      setTotalPages(response.total_pages);
      if (loading) {
        let new_array = categories.concat(response[name]);
        setCategories(new_array);
        setPageNumber((prev) => prev + 1);
      } else {
        setCategories(response[name]);
        setPageNumber(1);
      }
      setLoading(false);
      setIsLoadingMore(false);
    } else {
      enqueueSnackbar(response.message, { variant: "error" });
      setLoading(false);
      setIsLoadingMore(false);
    }
  };

  const loadMoreData = () => {
    setIsLoadingMore(true);
    fetchCategories(searchText, true);
  };

  const lastBookElementRef = useCallback(
    (node) => {
      if (isLoadingMore) return;
      if (observer.current) observer.current.disconnect();
      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && totalPages >= pageNumber) {
          loadMoreData();
        }
      });
      if (node) observer.current.observe(node);
    },
    [isLoadingMore, totalPages, pageNumber, loadMorePath, observer]
  );

  const handleDeatilAffilations = (blog) => {
    let type = featureType == "Podcasts" ? "podcast-detail" : "blog-detail";
    navigate(
      `/${params.source_slug}/feature/${params.feature_slug}/${params?.category_slug}/${type}/${blog.slug}`,
      {
        state: { blog: blog },
      }
    );
  };

  useEffect(() => {
    if (!loading) {
      const timeoutId = setTimeout(() => {
        fetchCategories(loadMorePath, searchText);
      }, 800);
      return () => clearTimeout(timeoutId);
    }
  }, [searchText]);

  useEffect(() => {
    setFeatureType(
      getFeatureType(
        params.source_slug,
        params.feature_slug,
        userInfo?.navbar || []
      )
    );
  }, [userInfo]);

  useEffect(() => {
    if (featureType) {
      fetchCategories(load_more_path, searchText, false);
    }
  }, [featureType]);

  useEffect(() => {
    setBreadCrumb([
      {
        name: `${show_proper_words(params?.source_slug)}`,
        path: `/${params?.source_slug}`,
        active: false,
      },
      {
        name: `${params?.feature_slug}`,
        path: `/${params?.source_slug}/feature/${params?.feature_slug}`,
        active: false,
      },
      {
        name: `Blog List`,
        path: `/${params?.source_slug}/feature/${params?.feature_slug}/${params?.category_slug}`,
        active: true,
      },
    ]);
  }, []);

  return (
    <div className="container-fluid ">
      <div className=" d-flex mt-3 justify-content-between mb-2">
        <div className="heading-main mb-3">
          <h3>
            {show_proper_words(params?.category_slug)} {featureType}
          </h3>
        </div>{" "}
        <div className="heading-main mb-3">
          <TextField
            variant="outlined"
            placeholder="Search..."
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            sx={{ width: 300 }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon sx={{ fontSize: 21 }} />
                </InputAdornment>
              ),
            }}
          />
        </div>
      </div>

      {loading ? (
        <PartnersSkeleton />
      ) : (
        <div className="row g-4">
          {categories && categories.length > 0 ? (
            <>
              {categories.map((item, index) => {
                return (
                  <BlogCard
                    item={item}
                    index={index}
                    handleDeatilAffilations={handleDeatilAffilations}
                  />
                );
              })}
            </>
          ) : (
            <div className="col-12">
              <RecordNotFound title={`No ${featureType}`} />
            </div>
          )}
          {/* {totalPages >= pageNumber ? (
            <div className="col-12 text-center mt-3">
              <span
                ref={lastBookElementRef}
                className="mt-3"
                onClick={loadMoreData}
                id="load-more-feed"
              >
                {isLoadingMore ? (
                  <CircularProgress color="primary" size="1.5rem" />
                ) : (
                  ""
                )}
              </span>
            </div>
          ) : (
            ""
          )} */}
        </div>
      )}
    </div>
  );
}
